<template>
    <div class="publicStatic">
      <div>
        <el-row
          :gutter="12"
          type="flex"
          class="row-bg"
          justify="space-around"
          style="margin-bottom: 10px;"
        >
          <el-col :span="4">
              <el-input
                size="mini"
                placeholder="请输入跟进人"
                v-model="form.userName"
                style="margin-right: 6px;"
              ></el-input>
          </el-col>
          <el-col :span="8">
              <el-date-picker
                style="margin-right: 6px;"
                v-model="dateTime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="mini"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                :clearable="false"
              >
              </el-date-picker>
          </el-col>
          <el-col :span="12">
            <div style="display: flex;align-items: center;">
              <el-button
                @click="searchData"
                size="mini"
                type="primary"
                icon="el-icon-search"
                >查询</el-button
              >
              <el-button
                @click="reset"
                size="mini"
                type="primary"
                icon="el-icon-search"
                >重置</el-button
              >
              <el-button @click="exportData()" size="mini" type="primary"
                >导出</el-button
              >
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-table :data="tableData" style="width: 100%;height: 100%;">
            <el-table-column
              label="序号"
              type="index"
              width="100"
              align="center"
            />
            <el-table-column prop="userName" label="跟进人" align="center" />
            <el-table-column prop="deptName" label="所属部门" align="center" />
            <el-table-column prop="leader" label="直接上级" align="center" />
            <el-table-column prop="delayTotal" label="延期次数" align="center" sortable />
            <el-table-column prop="cfSort" label="延期处罚排名" align="center" sortable >
            </el-table-column>
          </el-table>
          <div style="display: flex;justify-content: center;margin-top: 10px;">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              @current-change="checkPage"
            >
            </el-pagination>
          </div>
        </el-row>
      </div>
    </div>
  </template>
  
  <script>
  import { querySessionsResultList, exportSessionResult } from "@/api/dayqing";
  import moment from "moment";
  
  export default {
    name: "ResultStatic",
    data() {
      return {
        form: {
          createName: "",
          beginTime: "",
          endTime: "",
        },
        dateTime: [],
        tableData: [],
        pageType: {
},
        total: undefined
      };
    },
    mounted() {
      this.initParam()
      this.querySessionsResultList();
    },
    methods: {
      searchData() {
        this.querySessionsResultList();
      },
      async querySessionsResultList() {
        this.form.beginTime = this.dateTime[0];
        this.form.endTime = this.dateTime[1];
        const { code, rows, total } = await querySessionsResultList({
          ...this.form,
          'params[beginTime]': this.dateTime[0],
          'params[endTime]': this.dateTime[1],
          ...this.pageType
        });
        if (code != 0) return;
        this.tableData = rows;

        // 构建处罚排名
        this.tableData.forEach((item,index)=>{
            item.cfSort = index + 1 + (this.pageType.pageNum-1) * this.pageType.pageSize
        })

        this.total = total;
      },
      checkPage(val) {
        this.pageType.pageNum = val;
        this.querySessionsResultList();
      },

      exportData() {
        exportSessionResult({
          ...this.form,
          'params[beginTime]': this.dateTime[0],
          'params[endTime]': this.dateTime[1],
        }).then(res => {
          const blob = new Blob([res.data]);
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", `会议纪要结果统计.xls`);
          document.body.appendChild(link);
          link.click();
          setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }, 0);
        });
      },

        // 重置
    reset() {
      this.initParam()
      this.querySessionsResultList();
    },
    // 初始化参数
    initParam() {
      this.dateTime =  [
          moment()
            .subtract(6, "days")
            .startOf("day")
            .format("YYYY-MM-DD HH:mm:ss"),
          moment()
            .subtract(0, "days")
            .endOf("day")
            .format("YYYY-MM-DD HH:mm:ss")
        ]
        this.form = {}
        this. pageType = {
          pageNum: 1,
          pageSize: 10
        }
      }
    },
  
  };
  </script>
  
  <style lang="scss" scoped></style>
  


// WEBPACK FOOTER //
// src/components/MeetingMinute/ResultStatic.vue